var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 54,
    viewBox: "0 0 51 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0287 26.8751C12.0287 24.2368 12.721 21.7654 13.9237 19.6492V10.6729H5.37477C1.98176 15.2998 0.142578 20.9388 0.142578 26.8751C0.142578 32.8114 1.98176 38.4504 5.37477 43.0774H13.9237V34.101C12.721 31.9848 12.0287 29.5134 12.0287 26.8751Z",
    fill: "#FBBD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 41.0194L19.5566 47.2597L25.4997 53.4999C31.1535 53.4999 36.5238 51.5688 40.9304 48.0061V39.0393H32.3906C30.3576 40.3067 27.9939 41.0194 25.4997 41.0194Z",
    fill: "#0F9D58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9239 34.1008L5.375 43.0772C6.05198 44.0008 6.7851 44.8775 7.56978 45.7017C12.3591 50.7304 18.7268 53.5 25.5 53.5V41.0195C20.5846 41.0195 16.2766 38.2405 13.9239 34.1008Z",
    fill: "#31AA52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8567 26.875C50.8569 25.2573 50.7179 23.643 50.4414 22.0516L50.2185 20.7725H25.4995V33.2529H37.5295C36.3784 35.6579 34.5949 37.666 32.3903 39.0395L40.9301 48.0063C41.8097 47.2955 42.6447 46.5257 43.4297 45.7018C48.219 40.6729 50.8567 33.9868 50.8567 26.875Z",
    fill: "#3C79E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0252 16.8733L36.0757 17.9763L44.4805 9.15138L43.43 8.04832C38.6407 3.01952 32.273 0.25 25.4997 0.25L19.5566 6.49023L25.4997 12.7305C29.0979 12.7305 32.4808 14.2017 35.0252 16.8733Z",
    fill: "#CF2D48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4996 12.7305V0.25C18.7264 0.25 12.3587 3.01952 7.56929 8.04821C6.78457 8.87245 6.05144 9.74913 5.37451 10.6728L13.9234 19.6491C16.2762 15.5095 20.5842 12.7305 25.4996 12.7305Z",
    fill: "#EB4132"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.dd255d967ad1aecfb53c3b669e3d0d08.svg";
export { ForwardRef as ReactComponent };